import { render, staticRenderFns } from "./config-modal.vue?vue&type=template&id=386cc507&scoped=true"
import script from "./config-modal.vue?vue&type=script&lang=js"
export * from "./config-modal.vue?vue&type=script&lang=js"
import style0 from "./config-modal.vue?vue&type=style&index=0&id=386cc507&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386cc507",
  null
  
)

export default component.exports